export default __webpack_public_path__ + "static/media/profile_photo.003ed931.svg";